/**
 * Returns the owner of local offline data: the subject, extended by the tenant if one was chosen,
 * so that the records of different employers never mix on the device (T-105).
 *
 * @param subject - OIDC subject.
 * @param tenantId - Chosen tenant or `null`.
 * @returns The owner key.
 */
export function ownerKey(subject: string, tenantId: string | null): string {
  const key = tenantId === null ? subject : `${subject}@${tenantId}`;
  return key;
}
